import { frontendURL } from 'dashboard/helper/URLHelper.js';

const driveRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/drive'),
      name: 'drive_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: () => import('../crm/pages/CrmDrivePage.vue'),
    },
  ],
};

export default driveRoutes;
